// Ported from the Creative OS mock kit (app-creative/src/kit, docs/CREATIVE_V2.md rule 5):
// the same components, styled through kit.css, which maps the mock's token names onto
// this app's theme variables so both themes work without a second design pass.
import type { ReactNode } from 'react'
import './kit.css'

export function Spark({ data, color, h = 26 }: { data: number[]; color: string; h?: number }) {
  if (data.length < 2) return null
  const w = 120, min = Math.min(...data), max = Math.max(...data), span = max - min || 1
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * w},${h - 2 - ((v - min) / span) * (h - 4)}`).join(' ')
  return <svg aria-hidden="true" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ width: '100%', height: h }}><polyline fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke" points={pts} /></svg>
}

export function Word({ tone, children }: { tone: 'good' | 'warn' | 'bad' | 'info' | 'quiet' | 'ink'; children: ReactNode }) {
  return <span className={`kit-word kit-${tone}`}>{children}</span>
}

export function Caveat({ children }: { children: ReactNode }) {
  return <p className="kit-sub kit-caveat">{children}</p>
}

export function Drawer({ title, onClose, children }: { title: ReactNode; onClose: () => void; children: ReactNode }) {
  return (
    <aside role="dialog" aria-label="Detail" className="kit kit-drawer">
      <div className="kit-drawer-head"><b>{title}</b><button className="kit-btn sm quiet" onClick={onClose} aria-label="Close">×</button></div>
      <div className="kit-drawer-body">{children}</div>
    </aside>
  )
}

/** A creative thumbnail that opens the drawer. Hides itself when the proxy has no image. */
export function Thumb({ src, title, onOpen, size = 56 }: { src: string; title: string; onOpen: () => void; size?: number }) {
  return (
    <button className="kit-thumb" style={{ width: size, height: size * 1.25 }} title={title} onClick={e => { e.stopPropagation(); onOpen() }} aria-label={`Open ${title}`}>
      <img src={src} alt="" loading="lazy" onError={e => { (e.target as HTMLImageElement).style.visibility = 'hidden' }} />
    </button>
  )
}
